import _ from 'underscore'

const formErrors = () => []

/**
 * @mixin
 */
export default {
    props: {
        /**
         * Array of validation errors
         */
        errors: {
            type: Array,
            default: formErrors
        }
    },
    data: () => ({
        formErrors: formErrors()
    }),
    methods: {
        clearFieldErrors (field) {
            const vm = this
            vm.formErrors = _.reject(vm.formErrors, {field})
        },
        initFormErrors: formErrors,
        resetFormErrors () {
            const vm = this
            vm.formErrors = vm.initFormErrors()

            /**
             * Emit reset:errors event
             * @event reset:errors
             */
            this.$emit('reset:errors')
        },
        setFormErrors () {
            const vm = this
            vm.formErrors = {...vm.errors}
        }
    },
    computed: {
        fieldErrors () {
            const vm = this
            return (field) => {
                const errors = _.where(vm.formErrors, {field})
                return _.pluck(errors, 'message')
            }
        }
    },
    watch: {
        errors () {
            this.setFormErrors()
        }
    },
    created () {
        this.setFormErrors()
    },
    destroyed () {
        this.resetFormErrors()
    }
}
